import { render, staticRenderFns } from "./professional-avatar.vue?vue&type=template&id=1447de52&scoped=true&"
import script from "./professional-avatar.vue?vue&type=script&lang=js&"
export * from "./professional-avatar.vue?vue&type=script&lang=js&"
import style0 from "./professional-avatar.vue?vue&type=style&index=0&id=1447de52&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1447de52",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1447de52')) {
      api.createRecord('1447de52', component.options)
    } else {
      api.reload('1447de52', component.options)
    }
    module.hot.accept("./professional-avatar.vue?vue&type=template&id=1447de52&scoped=true&", function () {
      api.rerender('1447de52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/partnership/components/professional-avatar.vue"
export default component.exports